import * as React from 'react';
import { ModalWindow } from '../../../../modal';
import * as styles from './styles.module.css';
import { GroupedSelectMobileOptions } from '../GroupedSelectMobileOptions';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function GroupedSelectMobileModal(props) {
  var open = props.open,
    onClose = props.onClose,
    groups = props.groups,
    onChange = props.onChange,
    value = props.value,
    title = props.title;
  var handleChange = React.useCallback(function (value) {
    if (onChange) {
      onChange(value);
    }
    onClose();
  }, [onChange, onClose]);
  return /*#__PURE__*/_jsx(ModalWindow, {
    fixed: true,
    open: open,
    onClose: onClose,
    title: title,
    width: 648,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['list'],
      role: "listbox",
      children: groups.map(function (group) {
        var key = group.key,
          label = group.label,
          leftAdornment = group.leftAdornment,
          options = group.options;
        return /*#__PURE__*/_jsxs("div", {
          className: styles['group-wrapper'],
          children: [/*#__PURE__*/_jsx("div", {
            className: styles['group'],
            children: /*#__PURE__*/_jsxs("div", {
              className: styles['group-label'],
              children: [!!leftAdornment && /*#__PURE__*/_jsx("div", {
                className: styles['icon'],
                children: leftAdornment
              }), /*#__PURE__*/_jsx("div", {
                className: styles['label'],
                children: label
              })]
            })
          }), /*#__PURE__*/_jsx(GroupedSelectMobileOptions, {
            indented: !!leftAdornment,
            options: options,
            value: value,
            onChange: handleChange
          })]
        }, key);
      })
    })
  });
}